export default __webpack_public_path__ + "static/media/4.2cd425e1.jpg";